<script lang="ts">
    import { Answer } from '../types/Answer'

    import type { Stats } from '../types/Stats'
    import { Formatter } from '../util/Formatter'

    export let stats: Stats

    export let size: 'normal' | 'large' = 'normal'
</script>

<div class="statsbar {size}">
    <div class="bar">
        {#if stats[Answer.Yes] > 0}
            <div style="--color:var(--color-yes);--share:{stats[Answer.Yes]}" />
        {/if}
        {#if stats[Answer.MostlyYes] > 0}
            <div style="--color:var(--color-mostly-yes);--share:{stats[Answer.MostlyYes]}" />
        {/if}
        {#if stats[Answer.MostlyNo] > 0}
            <div style="--color:var(--color-mostly-no);--share:{stats[Answer.MostlyNo]}" />
        {/if}
        {#if stats[Answer.No] > 0}
            <div style="--color:var(--color-no);--share:{stats[Answer.No]}" />
        {/if}
        {#if stats[Answer.NotRelevant] > 0}
            <div style="--color:var(--color-not-relevant);--share:{stats[Answer.NotRelevant]}" />
        {/if}
    </div>
    <div class="text">
        {#if stats[Answer.Yes] > 0}
            <div style="--share:{stats[Answer.Yes]}">
                {Formatter.formatPercent(stats[Answer.Yes] / stats.total)}
            </div>
        {/if}
        {#if stats[Answer.MostlyYes] > 0}
            <div style="--share:{stats[Answer.MostlyYes]}">
                {Formatter.formatPercent(stats[Answer.MostlyYes] / stats.total)}
            </div>
        {/if}
        {#if stats[Answer.MostlyNo] > 0}
            <div style="--share:{stats[Answer.MostlyNo]}">
                {Formatter.formatPercent(stats[Answer.MostlyNo] / stats.total)}
            </div>
        {/if}
        {#if stats[Answer.No] > 0}
            <div style="--share:{stats[Answer.No]}">
                {Formatter.formatPercent(stats[Answer.No] / stats.total)}
            </div>
        {/if}
        {#if stats[Answer.NotRelevant] > 0}
            <div style="--share:{stats[Answer.NotRelevant]}">
                {Formatter.formatPercent(stats[Answer.NotRelevant] / stats.total)}
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    .statsbar {
        & > div {
            display: flex;
            flex-direction: row;
            column-gap: 0.375rem;
            div {
                flex-grow: var(--share);
                width: 0;
            }
        }
        .bar div {
            height: 1.25rem;
            background-color: var(--color);
            border-radius: 0.3125rem;
        }
        &.large {
            .bar div {
                height: 1.5625rem;
            }
            & > div {
                column-gap: 0.5625rem;
            }
        }
        .text div {
            min-width: 1.5rem;
            height: 2.21rem;
            padding-top: 0.5rem;
        }
    }
</style>
